import { render } from "./SystemCheckScreen.vue?vue&type=template&id=e2f9ecb8&scoped=true"
import script from "./SystemCheckScreen.vue?vue&type=script&lang=js"
export * from "./SystemCheckScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=e2f9ecb8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f9ecb8"]])

export default __exports__